<template>
    <div id="feiGeExam">
        <div class="el-tabs el-tabs--left">
            <div class="el-tabs__header is-left">
                <div class="el-tabs__nav-wrap is-left">
                    <div class="el-tabs__nav-scroll">
                        <div class="el-tabs__nav is-left">
                            <div class="el-tabs__active-bar is-left" style="height: 50px; transform: translateY(0px);"></div>
                            <div id="tab-first" class="el-tabs__item js-tab is-left is-active">
                                <div class="tab-slot">
                                    <p class="title">1、登录飞鸽工作台</p>
                                </div>
                            </div>
                            <div id="tab-second" class="el-tabs__item js-tab is-left">
                                <div class="tab-slot">
                                    <p class="title">2、基础设置（上）</p>
                                </div>
                            </div>
                            <div id="tab-third" class="el-tabs__item js-tab is-left">
                                <div class="tab-slot">
                                    <p class="title">2、基础设置（下）</p>
                                </div>
                            </div>
                            <div id="tab-four" class="el-tabs__item js-tab is-left">
                                <div class="tab-slot">
                                    <p class="title">3、会话窗口</p>
                                </div>
                            </div>
                            <div id="tab-five" class="el-tabs__item js-tab is-left">
                                <div class="tab-slot">
                                    <p class="title">4、商品插件</p>
                                </div>
                            </div>
                            <div id="tab-six" class="el-tabs__item js-tab is-left">
                                <div class="tab-slot">
                                    <p class="title">5、订单插件</p>
                                </div>
                            </div>
                            <div id="tab-seven" class="el-tabs__item js-tab is-left">
                                <div class="tab-slot">
                                    <p class="title">6、退出飞鸽</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="el-tabs__content">
                <div id="tab-first-content" class="el-tab-pane">
                    <div id="stoptip-first" class="stoptip">
                        <div class="tip">
                            <span class="el-icon-success"></span>
                            <p>
                                <a class="startstudy" @click="startStudy">开始实操练习</a>
                            </p>
                        </div>
                    </div>
                    <div id="content-first" class="content">
                        <div class="con-left">
                            <div v-show="isShowQnIcon" class="qnbox">
                                <img class="qnbg" src="../../../static/feige/fgbg1-1.png" />
                                <div @mouseenter="showLoginImg" class="qnicon01"></div>
                            </div>
                            <div v-show="isShowQnIcon2" class="qnbox">
                                <img class="qnbg" src="../../../static/feige/fgbg1-2.png" />
                                <div id="select" class="qnicon01" @dblclick="showLoginImg2"></div>
                            </div>
                            <div v-show="isShowIcon3" class="qnbox">
                                <img class="qnbg left-img" src="../../../static/feige/fgbg1-3.png" />
                                <div class="fgicon03" @click="showLoginImg3"></div>
                            </div>
                            <div v-show="isShowIcon4" class="qnbox">
                                <img class="qnbg left-img" src="../../../static/feige/fgbg1-4.png" />
                                <div class="fgicon04" @mouseenter="showLoginImg4"></div>
                            </div>
                            <div v-show="isShowIcon5" class="qnbox">
                                <img class="qnbg left-img" src="../../../static/feige/fgbg1-5.png" />
                                <div class="fgicon05" @click="showLoginImg5"></div>
                            </div>
                            <div v-show="isShowIcon6" class="qnbox">
                                <img class="qnbg left-img" src="../../../static/feige/fgbg1-6.png" />
                                <div class="fgicon06" @click="showLoginImg6"></div>
                            </div>
                            <div v-show="isShowIcon7" class="qnbox login">
                                <img class="qnbg left-img" src="../../../static/feige/fgbg1-7.png" />
                                <input type="text" v-model.trim="name" class="name" />
                                <div class="fgicon07" @click="showLoginImg7"></div>
                            </div>
                            <div v-show="isShowIcon8" class="qnbox login">
                                <img class="qnbg left-img" src="../../../static/feige/fgbg1-8.png" />
                                <input type="text" v-model.trim="name" class="name" />
                                <input type="password" v-model.trim="password" autocomplete="new-password" class="password" />
                                <div class="fgicon08" @click="loginIn"></div>
                            </div>
                            <div v-show="isShowLogin1" class="qnbox">
                                <img class="qnbg" src="../../../static/feige/fgbg1-9.png" />
                                <div class="fgicon09" @mouseenter="loginIn1"></div>
                            </div>
                            <div v-show="isShowLogin2" class="qnbox">
                                <img class="qnbg" src="../../../static/feige/fgbg1-10.png" />
                                <div class="fgicon09" @click="loginIn2"></div>
                            </div>
                            <div v-show="isShowLogin3" class="qnbox">
                                <img class="qnbg" src="../../../static/feige/fgbg1-11.png" />
                                <div class="fgicon09" @contextmenu.prevent="loginIn3"></div>
                            </div>
                            <div v-show="isShowLogin4" class="qnbox">
                                <img class="qnbg" src="../../../static/feige/fgbg1-12.png" />
                                <div class="fgicon10" @click="loginIn4"></div>
                            </div>
                            <div v-show="isShowLogin5" class="qnbox">
                                <img class="qnbg" src="../../../static/feige/fgbg1-13.png" />
                            </div>
                        </div>
                        <div class="con-right">
                            <h3>
                                <span class="line"></span>
                                提示
                            </h3>
                            <!--双击图标-->
                            <p v-if="isShowQnIcon || isShowQnIcon2">请打开<span class="blod-span">左侧练习场</span>中的飞鸽客服工作台</p>
                            <!--登录-->
                            <template v-if="isShowIcon3">
                                <p>选择<span class="blod-span">我是商家</span></p>
                            </template>
                            <template v-if="isShowIcon4 || isShowIcon5">
                                <p>点击右上角的电脑图标，切换为<span class="blod-span">手机号登录</span></p>
                            </template>
                            <template v-if="isShowIcon6 || isShowIcon7 || isShowIcon8">
                                <p>注意：<span class="blod-span">正式任务</span>需提前将<span class="blod-span">自己的手机号</span>反馈给主管开通账号！</p>

                                <p>假设练习场<span class="blod-span">账号为：13853678478</span></p>
                                <p><span class="blod-span">验证码为：3346</span></p>
                            </template>
                            <template v-if="isShowLogin1 || isShowLogin2">
                                <p>鼠标<span class="blod-span">左键</span>点击<span class="blod-span">第2个</span>店铺，切换到第2个店铺</p>
                            </template>
                            <template v-if="isShowLogin3 || isShowLogin4">
                                <p>鼠标<span class="blod-span">右键</span>点击<span class="blod-span">第2个</span>店铺，<span class="blod-span">退出店铺</span>铺</p>
                            </template>
                        </div>
                    </div>
                    <div id="studytip-first" class="stoptip">
                        <div class="tip">
                            <span class="el-icon-success"></span>
                            <p>实操通关，进入下一关吧</p>
                            <p>
                                <a class="startstudy" @click="studyNext('#tab-second', 2, 'second')">GO，下一关</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div id="tab-second-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'second'}">
                    <div id="content-second" class="content">
                        <div class="con-left">
                            <div v-show="isShowSetUp" class="szbox">
                                <img class="szbg" src="../../../static/feige/2/fgbg2-1.png" />
                                <div @click="setUp" class="seticon01"></div>
                            </div>
                            <div v-show="isShowSetUp1" class="szbox">
                                <img class="szbg" src="../../../static/feige/2/fgbg2-2.png" />
                                <div @mouseenter="setUp1" class="seticon02"></div>
                            </div>
                            <div v-show="isShowSetUp2" class="szbox">
                                <img class="szbg" src="../../../static/feige/2/fgbg2-3.png" />
                                <div @click="setUp2" class="seticon02"></div>
                            </div>
                            <div v-show="isShowSetUp3" class="szbox">
                                <img class="szbg" src="../../../static/feige/2/fgbg2-4.png" />
                                <div @click="setUp3" class="seticon03"></div>
                            </div>
                            <div v-show="isShowSetUp4" class="szbox">
                                <img class="szbg" src="../../../static/feige/2/fgbg2-5.png" />
                                <div @mouseenter="setUp4" class="seticon04"></div>
                            </div>
                            <div v-show="isShowSetUp5" class="szbox">
                                <img class="szbg" src="../../../static/feige/2/fgbg2-6.png" />
                                <div @click="setUp5" class="seticon04"></div>
                            </div>
                            <div v-show="isShowSetUp6" class="szbox">
                                <img class="szbg" src="../../../static/feige/2/fgbg2-7.png" />
                                <div @mouseenter="setUp6" class="seticon05"></div>
                            </div>
                            <div v-show="isShowSetUp7" class="szbox">
                                <img class="szbg" src="../../../static/feige/2/fgbg2-8.png" />
                                <div @click="setUp7" class="seticon05"></div>
                            </div>
                            <div v-show="isShowSetUp8" class="szbox">
                                <img class="szbg" src="../../../static/feige/2/fgbg2-9.png" />
                                <div @mouseenter="setUp8" class="seticon06"></div>
                            </div>
                            <div v-show="isShowSetUp9" class="szbox">
                                <img class="szbg" src="../../../static/feige/2/fgbg2-10.png" />
                                <div @click="setUp9" class="seticon06"></div>
                            </div>
                            <div v-show="isShowSetUp10" class="szbox">
                                <img class="szbg" src="../../../static/feige/2/fgbg2-11.png" />
                            </div>
                        </div>
                        <div class="con-right">
                            <h3>
                                <span class="line"></span>
                                提示
                            </h3>
                            <p v-if="isShowSetUp || isShowSetUp1 || isShowSetUp2">请将状态切换为<span class="blod-span">在线</span></p>
                            <p v-if="isShowSetUp3 || isShowSetUp4 || isShowSetUp5">请将状态切换为<span class="blod-span">小休</span></p>
                            <p v-if="isShowSetUp6 || isShowSetUp7 || isShowSetUp8 || isShowSetUp9">请将当前会话的接待排序设置为：按<span class="blod-span">等待时长</span>由长到短排序</p>
                        </div>
                    </div>
                    <div id="studytip-second" class="stoptip">
                        <div class="tip">
                            <span class="el-icon-success"></span>
                            <p>实操通关，进入下一关吧</p>
                            <p>
                                <a class="startstudy" @click="studyNext('#tab-third', 3, 'third')">GO，下一关</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div id="tab-third-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'third'}">
                    <!-- <div id="stoptip-third" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div> -->
                    <div id="content-third" class="content">
                        <div class="con-left">
                            <div v-show="isShowSetDown" class="szbox">
                                <img class="szbg" src="../../../static/feige/2/fgbg2-11.png" />
                                <div @mouseenter="setDown()" class="setdown"></div>
                            </div>
                            <div v-show="isShowSetDown1" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-01.png" />
                                <div @click="setDown1()" class="setdown"></div>
                            </div>
                            <div v-show="isShowSetDown2" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-02.png" />
                                <div @mouseenter="setDown2()" class="setdown01"></div>
                            </div>
                            <div v-show="isShowSetDown3" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-03.png" />
                                <div @click="setDown3()" class="setdown01"></div>
                            </div>
                            <div v-show="isShowSetDown4" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-04.png" />
                                <div @mouseenter="setDown4()" class="setdown02"></div>
                            </div>
                            <div v-show="isShowSetDown5" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-05.png" />
                                <div @click="setDown5()" class="setdown02"></div>
                            </div>
                            <div v-show="isShowSetDown6" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-06.png" />
                                <div @mouseenter="setDown6()" class="setdown03"></div>
                            </div>
                            <div v-show="isShowSetDown7" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-07.png" />
                                <div @click="setDown7()" class="setdown03"></div>
                            </div>
                            <div v-show="isShowSetDown8" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-08.png" />
                                <div @mouseenter="setDown8()" class="setdown04"></div>
                            </div>
                            <div v-show="isShowSetDown9" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-09.png" />
                                <div @click="setDown9()" class="setdown04"></div>
                            </div>
                            <div v-show="isShowSetDown10" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-10.png" />
                                <div @click="setDown10()" class="setdown05"></div>
                            </div>
                            <div v-show="isShowSetDown11" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-11.png" />
                                <input type="text" v-model.trim="dyInput" class="dyInput" />
                                <div @click="setDown11()" class="setdown06"></div>
                            </div>
                            <div v-show="isShowSetDown12" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-12.png" />
                                <div @mouseenter="setDown12()" class="setdown07"></div>
                            </div>
                            <div v-show="isShowSetDown13" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-13.png" />
                                <div @click="setDown13()" class="setdown07"></div>
                            </div>
                            <div v-show="isShowSetDown14" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-14.png" />
                                <!-- <textarea v-model.trim="dynr" class="dynr"></textarea>
                                <input type="text" v-model.trim="bmdy" class="bmdy" /> -->
                                <div @click="setDown14()" class="dynr"></div>
                                <div @click="setDown15()" class="bmdy"></div>
                            </div>
                            <!-- 鲜甜短语内容 -->
                            <div v-show="isShowSetDown15" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-15.png" />
                                <textarea v-model.trim="dynr" class="dynr"></textarea>
                                <div @click="setDown16()" class="bmdy"></div>
                            </div>
                            <div v-show="isShowSetDown16" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-16.png" />
                                <textarea v-model.trim="dynr" class="dynr"></textarea>
                                <input type="text" v-model.trim="bmdy" class="bmdy" />
                                <div @mouseenter="setDown17()" class="setdown08"></div>
                            </div>
                            <!-- 先填编码配置 -->
                            <div v-show="isShowSetDown17" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-16.png" />
                                <input type="text" v-model.trim="bmdy" class="bmdy" />
                                <div @click="setDown18()" class="dynr"></div>
                            </div>
                            <div v-show="isShowSetDown18" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-15.png" />
                                <textarea v-model.trim="dynr" class="dynr"></textarea>
                                <input type="text" v-model.trim="bmdy" class="bmdy" />
                                <div @mouseenter="setDown19()" class="setdown08"></div>
                            </div>
                            <div v-show="isShowSetDown19" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-17.png" />
                                <div @click="setDown20()" class="setdown08"></div>
                            </div>
                            <div v-show="isShowSetDown20" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/1-18.png" />
                            </div>

                            <div v-show="isShowSetDown21" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/2-01.png" />
                                <div @mouseenter="setDown22()" class="setdown10"></div>
                            </div>
                            <div v-show="isShowSetDown22" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/2-02.png" />
                                <div @click="setDown23()" class="setdown10"></div>
                            </div>

                            <div v-show="isShowSetDown23" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/2-03.png" />
                                <div @mouseenter="setDown24()" class="setdown11"></div>
                            </div>
                            <!-- 先导入 -->
                            <div v-show="isShowSetDown24" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/2-04.png" />
                                <div @click="setDown25()" class="setdown11"></div>
                            </div>
                            <div v-show="isShowSetDown25" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/2-05.png" />
                                <div @click="setDown26()" class="setdown12"></div>
                            </div>
                            <div v-show="isShowSetDown26" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/2-06.png" />
                                <div @click="setDown27()" class="setdown13"></div>
                            </div>
                            <div v-show="isShowSetDown27" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/2-07.png" />
                                <div @click="setDown28()" class="setdown14"></div>
                            </div>
                            <div v-show="isShowSetDown28" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/2-08.png" />
                                <div @mouseenter="setDown29()" class="setdown15"></div>
                            </div>
                            <div v-show="isShowSetDown29" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/2-09.png" />
                                <div @click="setDown30()" class="setdown15"></div>
                            </div>

                            <!-- 先勾选 -->
                            <!-- <div v-show="isShowSetDown271" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/2-07.png" />
                                <div @click="setDown281()" class="setdown14"></div>
                            </div>
                            <div v-show="isShowSetDown281" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/2-08.png" />
                                <div @mouseenter="setDown281()" class="setdown11"></div>
                            </div>
                            <div v-show="isShowSetDown241" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/2-04.png" />
                                <div @click="setDown251()" class="setdown11"></div>
                            </div> -->



                            <div v-show="isShowSetDown30" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/2-10.png" />
                            </div>
                            <div v-show="isShowSetDown31" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/3-01.png" />
                                <div @mouseenter="setDown32()" class="setdown16"></div>
                            </div>
                            <div v-show="isShowSetDown32" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/3-02.png" />
                                <div @click="setDown33()" class="setdown16"></div>
                            </div>
                            <div v-show="isShowSetDown33" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/3-03.png" />
                                <div @mouseenter="setDown34()" class="setdown17"></div>
                            </div>
                            <div v-if="isShowSetDown34" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/3-04.png" />
                                <input type="file" @change="tirggerFile($event)" class="btn-file" />
                                <!-- <div @click="setDown35()" class="setdown16"></div> -->
                            </div>
                            <div v-show="isShowSetDown35" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/3-05.png" />
                                <div @mouseenter="setDown36()" class="setdown18"></div>
                            </div>
                            <div v-show="isShowSetDown36" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/3-06.png" />
                                <div @click="setDown37()" class="setdown18"></div>
                            </div>
                            <div v-show="isShowSetDown37" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/3-07.png" />
                            </div>

                            <div v-show="isShowSetDown38" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/4-001.png" />
                                <div @mouseenter="setDown39()" class="setdown19"></div>
                            </div>
                            <div v-show="isShowSetDown39" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/4-02.png" />
                                <div @click="setDown40()" class="setdown19"></div>
                            </div>
                            <div v-show="isShowSetDown40" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/4-03.png" />
                                <div @mouseenter="setDown41()" class="setdown20"></div>
                            </div>
                            <div v-show="isShowSetDown41" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/4-04.png" />
                                <div @click="setDown42()" class="setdown20"></div>
                            </div>
                            <div v-show="isShowSetDown42" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/4-05.png" />
                                <input type="text" class="kjdy03input" v-focus="true" @keyup.enter="setDown43()">
                                <div @click="setDown43()"  class="setdown21"></div>
                            </div>
                            <div v-show="isShowSetDown43" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/4-06.png" />
                            </div>

                            <div v-show="isShowSetDown431" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/4-03.png" />
                                <textarea v-model.trim="duanyuInputVal" @input="duanyuInput" class="input03" v-focus="true"></textarea>
                                <!-- <input type="text" v-model.trim="duanyuInputVal" @input="duanyuInput" class="input03" v-focus="true"> -->
                                <!-- <div class="input033"></div> -->
                            </div>
                            <div v-show="isShowSetDown432" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/4-05.png" />
                                <input type="text" class="kjdy03input" v-focus="true" @keyup.enter="setDown432()">
                                <div @click="setDown432()"  class="setdown21"></div>
                            </div>
                            <div v-show="isShowSetDown433" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/4-06.png" />
                            </div>
                            <div v-show="isShowSetDown434" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/4-03.png" />
                                <textarea v-model.trim="duanyuInputVal1" @input="duanyuInput1" class="input03" v-focus="true"></textarea>
                                <!-- <input type="text" v-model.trim="duanyuInputVal1" @input="duanyuInput1" class="input03" v-focus="true"> -->
                                <!-- <div class="input033"></div> -->
                            </div>

                            <div v-show="isShowSetDown44" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/4-07.png" />
                                <div @mouseenter="setDown45()" class="setdown22"></div>
                            </div>
                            <div v-show="isShowSetDown45" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/4-08.png" />
                                <div @click="setDown46()" class="setdown22"></div>
                            </div>

                            <div v-show="isShowSetDown451" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/4-05.png" />
                                <input type="text" class="kjdy03input" v-focus="true" @keyup.enter="setDown461()">
                                <div @click="setDown461()"  class="setdown21"></div>
                            </div>

                            <div v-show="isShowSetDown452" class="szbox">
                                <img class="szbg" src="../../../static/feige/3/4-06.png" />
                            </div>

                        </div>
                        <div class="con-right">
                            <h3>
                                <span class="line"></span>
                                提示
                            </h3>
                            <p v-if="isShowSetDown || isShowSetDown1 || isShowSetDown2 || isShowSetDown3">请从<span class="blod-span">客服管理</span>进入<span class="blod-span">客服工具</span></p>
                            <p v-if="isShowSetDown4 || isShowSetDown5">选择客服工具中的<span class="blod-span">快捷短语</span></p>
                            <p v-if="isShowSetDown6 || isShowSetDown7">点击<span class="blod-span">新建短语</span></p>
                            <p v-if="isShowSetDown8 || isShowSetDown9 || isShowSetDown10 || isShowSetDown11">请<span class="blod-span">新增</span>一个<span class="blod-span">催单</span>组</p>
                            <p v-if="isShowSetDown12 || isShowSetDown13">选择<span class="blod-span">催单</span>组</p>
                            <template v-if="isShowSetDown14 || isShowSetDown15 || isShowSetDown16 || isShowSetDown17 || isShowSetDown17 || isShowSetDown18 || isShowSetDown19">
                                <p>添加催单短语内容：<span class="blod-span">亲亲，喜欢的话就下单吧，早拍早发货哦！</span></p>
                                <p>编码短语设置为：<span class="blod-span">催单</span>点击<span class="blod-span">确定</span>按钮进行保存</p>
                            </template>
                            <template v-if="isShowSetDown20 || isShowSetDown21 || isShowSetDown22">
                                <p>请点击<span class="blod-span">模板库导入</span></p>
                            </template>
                            <template v-if="isShowSetDown23 || isShowSetDown24 || isShowSetDown25 || isShowSetDown26 || isShowSetDown27 || isShowSetDown28 || isShowSetDown29">
                                <p>请将<span class="blod-span">分组</span>设置为<span class="blod-span">问候语</span>，并选择<span class="blod-span">前面2条</span>快捷问候语；</p>
                                <p>点击<span class="blod-span">确定导入</span>按钮</p>
                            </template>
                            <template v-if="isShowSetDown30 || isShowSetDown31 || isShowSetDown32 ||isShowSetDown33 || isShowSetDown34 || isShowSetDown35 || isShowSetDown36">
                                <p>1.先<span class="blod-span">下载下方的飞鸽快捷短语</span>表格；</p>
                                <p>2.点击<span class="blod-span">批量导入</span>按钮；</p>
                                <p>3.点击<span class="blod-span">添加文件</span>，选择下载的飞鸽快捷短语表格（可以先将下载的表格另存到桌面上，方便导入时快速找到表格）；</p>
                                <p>4.点击<span class="blod-span">导入</span>按钮；</p>
                                <p><a @click="downloadKjdyFile">点击下载“飞鸽快捷短语.csv”</a></p>
                            </template>
                            <template v-if="isShowSetDown37 || isShowSetDown38 || isShowSetDown39">
                                <p>点击右侧的<span class="blod-span">快捷短语；</span></p>
                            </template>
                            <template v-if="isShowSetDown40 || isShowSetDown41 || isShowSetDown42">
                                <p>请采用<span class="blod-span">鼠标左键</span>点击快捷短语的方式，给当前用户发送欢迎语：<span class="blod-span">您好，欢迎光临本店，请问有什么可以帮到您？</span></p>
                            </template>
                            <template v-if="isShowSetDown43 || isShowSetDown431 || isShowSetDown432 || isShowSetDown433">
                                <p>请采用输入<span class="blod-span">/您好</span>的方式，给当前用户发送欢迎语：<span class="blod-span">您好，欢迎光临本店，请问有什么可以帮到您？</span></p>
                            </template>
                            <template v-if="isShowSetDown434 || isShowSetDown44 || isShowSetDown45 || isShowSetDown451 || isShowSetDown452">
                                <p>请采用输入文本<span class="blod-span">您好</span>的方式，给当前用户发送欢迎语：<span class="blod-span">您好，欢迎光临本店，请问有什么可以帮到您？</span></p>
                            </template>

                        </div>
                    </div>
                    <div id="studytip-third" class="stoptip">
                        <div class="tip">
                            <span class="el-icon-success"></span>
                            <p>实操通关，进入下一关吧</p>
                            <p>
                                <a class="startstudy" @click="studyNext('#tab-four', 4, 'four')">GO，下一关</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div id="tab-four-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'four'}">
                    <!-- <div id="stoptip-four" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div> -->
                    <div id="content-four" class="content">
                        <div class="con-left">
                            <div v-show="isShowSession" class="szbox">
                                <img class="szbg" src="../../../static/feige/4/1.png" />
                                <div @mouseenter="four()" class="four01"></div>
                            </div>
                            <div v-show="isShowSession1" class="szbox">
                                <img class="szbg" src="../../../static/feige/4/2.png" />
                                <div @click="four1()" class="four01"></div>
                            </div>
                            <div v-show="isShowSession2" class="szbox">
                                <img class="szbg" src="../../../static/feige/4/3.png" />
                                <div @mouseenter="four2()" class="four02"></div>
                            </div>
                            <div v-show="isShowSession3" class="szbox">
                                <img class="szbg" src="../../../static/feige/4/4.png" />
                                <div @click="four3()" class="four02"></div>
                            </div>
                            <div v-show="isShowSession4" class="szbox">
                                <img class="szbg" src="../../../static/feige/4/5.png" />
                            </div>

                        </div>
                        <div class="con-right">
                            <h3>
                                <span class="line"></span>
                                提示
                            </h3>
                            <template v-if="isShowSession || isShowSession1 || isShowSession2 || isShowSession3 || isShowSession4">
                                <p>请将当前用户<span class="blod-span">转接</span>给<span class="blod-span">军瑞</span></p>
                            </template>
                        </div>
                    </div>
                    <div id="studytip-four" class="stoptip">
                        <div class="tip">
                            <span class="el-icon-success"></span>
                            <p>实操通关，进入下一关吧</p>
                            <p>
                                <a class="startstudy" @click="studyNext('#tab-five', 5, 'five')">GO，下一关</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div id="tab-five-content" class="el-tab-pane"  :class="{mynone: tabCurrent !== 'five'}">
                    <!-- <div id="stoptip-five" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div> -->
                    <div id="content-five" class="content">
                        <div class="con-left">
                            <div v-show="isShowFive" class="szbox">
                                <img class="szbg" src="../../../static/feige/5/1.png" />
                                <div @mouseenter="five()" class="five01"></div>
                            </div>
                            <div v-show="isShowFive1" class="szbox">
                                <img class="szbg" src="../../../static/feige/5/2.png" />
                                <div @click="five1()" class="five01"></div>
                            </div>
                            <div v-show="isShowFive2" class="szbox">
                                <img class="szbg" src="../../../static/feige/5/3.png" />
                                <div @mouseenter="five2()" class="five02"></div>
                            </div>
                            <div v-show="isShowFive3" class="szbox">
                                <img class="szbg" src="../../../static/feige/5/4.png" />
                                <div @click="five3()" class="five02"></div>
                            </div>
                            <div v-show="isShowFive4" class="szbox">
                                <img class="szbg" src="../../../static/feige/5/5.png" />
                            </div>
                            <div v-show="isShowFive5" class="szbox">
                                <img class="szbg" src="../../../static/feige/5/6.1.png" />
                                <div @mouseenter="five5()" class="five03"></div>
                            </div>
                            <div v-show="isShowFive6" class="szbox">
                                <img class="szbg" src="../../../static/feige/5/6.2.png" />
                                <div @click="five6()" class="five03"></div>
                            </div>
                            <div v-show="isShowFive7" class="szbox">
                                <img class="szbg" src="../../../static/feige/5/7.png" />
                                <div @mouseenter="five7()" class="five04"></div>
                            </div>
                            <div v-show="isShowFive8" class="szbox">
                                <img class="szbg" src="../../../static/feige/5/8.png" />
                                <div @click="five8()" class="five04"></div>
                            </div>
                            <div v-show="isShowFive9" class="szbox">
                                <img class="szbg" src="../../../static/feige/5/9.png" />
                            </div>
                        </div>
                        <div class="con-right">
                            <h3>
                                <span class="line"></span>
                                提示
                            </h3>
                            <template v-if="isShowFive || isShowFive1 || isShowFive2 || isShowFive3 || isShowFive4">
                                <p>请点击商品插件，将<span class="blod-span">全部商品</span>中<span class="blod-span">销量最高</span>的<span class="blod-span">腰带</span>链接发送给用户</p>
                            </template>
                            <template v-if="isShowFive5 || isShowFive6 || isShowFive7 || isShowFive8 || isShowFive9">
                                <p>请将<span class="blod-span">浏览足迹</span>中<span class="blod-span">销量最高</span>的<span class="blod-span">腰带</span>链接发送给用户</p>
                            </template>
                        </div>
                    </div>
                    <div id="studytip-five" class="stoptip">
                        <div class="tip">
                            <span class="el-icon-success"></span>
                            <p>实操通关，进入下一关吧</p>
                            <p>
                                <a class="startstudy" @click="studyNext('#tab-six', 6, 'six')">GO，下一关</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div id="tab-six-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'six'}">
                    <!-- <div id="stoptip-six" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div> -->
                    <div id="content-six" class="content">
                        <div class="con-left">
                            <div v-show="isShowSix" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/1-1.png" />
                                <div @mouseenter="six()" class="six01"></div>
                            </div>
                            <div v-show="isShowSix1" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/1-2.png" />
                                <div @click="six1()" class="six01"></div>
                            </div>
                            <div v-show="isShowSix2" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/1-3.png" />
                                <!-- <input type="text" @input="beiZhuInput" v-model.trim="beizhu" class="beizhu" /> -->
                                <textarea v-model.trim="beizhu" @input="beiZhuInput" class="beizhu"></textarea>
                                <div @click="six121()" class="six03"></div>
                                <div @click="six122()" class="six033"></div>
                            </div>
                            <div v-show="isShowSix3" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/1-4.png" />
                                <div @click="six121()" class="six03"></div>
                                <div @click="six3()" class="six02"></div>
                            </div>
                            <div v-show="isShowSix4" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/1-5.png" />
                                <div @mouseenter="six4()" class="six03"></div>
                            </div>
                            <div v-show="isShowSix5" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/1-6.png" />
                                <div @click="six5()" class="six03"></div>
                            </div>
                            <div v-show="isShowSix6" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/1-7.png" />
                            </div>
                            <div v-show="isShowSix7" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/2-11.png" />
                                <div @mouseenter="six6()" class="six04"></div>
                            </div>
                            <div v-show="isShowSix8" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/2-12.png" />
                                <div @click="six7()" class="six04"></div>
                            </div>
                            <div v-show="isShowSix9" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/2-2.png" />
                            </div>
                            <div v-show="isShowSix10" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/3-1.png" />
                                <div @mouseenter="six8()" class="six05"></div>
                            </div>
                            <div v-show="isShowSix11" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/3-2.png" />
                                <div @click="six9()" class="six05"></div>
                            </div>
                            <div v-show="isShowSix12" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/3-3.png" />
                            </div>
                            <div v-show="isShowSix13" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/4-1.png" />
                                <div @mouseenter="six10()" class="six06"></div>
                            </div>
                            <div v-show="isShowSix14" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/4-2.png" />
                                <div @click="six11()" class="six06"></div>
                            </div>
                            <div v-show="isShowSix15" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/4-3.png" />
                                <input type="text" v-model.trim="yjgj" class="yjgj" />
                                <input type="text" v-model.trim="yfInput" class="yfInput" />
                                <div @mouseenter="six12()" class="six07"></div>
                            </div>
                            <div v-show="isShowSix16" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/4-4.png" />
                                <div @click="six13()" class="six07"></div>
                            </div>
                            <div v-show="isShowSix17" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/4-5.png" />
                            </div>
                            <div v-show="isShowSix18" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/5-2.png" />
                                <div @mouseenter="six14()" class="six08"></div>
                            </div>
                            <div v-show="isShowSix19" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/5-3.png" />
                                <div @click="six15()" class="six08"></div>
                            </div>
                            <div v-show="isShowSix20" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/5-4.png" />
                                <div @click="six16()" class="six081"></div>
                            </div>
                            <div v-show="isShowSix21" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/5-5.png" />
                                <input type="text" v-model.trim="sjhm" class="sjhm" />
                                <div @mouseenter="six17()" class="six09"></div>
                            </div>
                            <div v-show="isShowSix22" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/5-6.png" />
                                <div @click="six18()" class="six09"></div>
                            </div>
                            <div v-show="isShowSix23" class="szbox">
                                <img class="szbg" src="../../../static/feige/6/5-7.png" />
                            </div>
                        </div>
                        <div class="con-right">
                            <h3>
                                <span class="line"></span>
                                提示
                            </h3>
                            <template v-if="isShowSix || isShowSix1 || isShowSix2 || isShowSix3 || isShowSix4 || isShowSix5 || isShowSix6">
                                <p>假设此商家规定<span class="blod-span">红色彩旗跟发货相关</span></p>
                                <p>请给该用户添加<span class="blod-span">备注</span>内容：<span class="blod-span">用户要求发顺丰</span>并<span class="blod-span">选择对应的彩旗</span></p>
                            </template>
                            <template v-if="isShowSix7 || isShowSix8 || isShowSix9">
                                <p>请给用户发送<span class="blod-span">核对地址</span>卡片</p>
                            </template>
                            <template v-if="isShowSix10 || isShowSix11 || isShowSix12">
                                <p>请给用户发送订单<span class="blod-span">催付</span>卡片</p>
                            </template>
                            <template v-if="isShowSix13 || isShowSix14 || isShowSix15 || isShowSix16 || isShowSix17">
                                <p>请采用<span class="blod-span">一键改价</span>方式，将<span class="blod-span">最终实付价</span>改为<span class="blod-span">48</span>元，<span class="blod-span">运费</span>改为<span class="blod-span">10</span>元</p>
                            </template>
                            <template v-if="isShowSix18 || isShowSix19 || isShowSix20 || isShowSix21 || isShowSix22 || isShowSix23">
                                <p>请在<span class="blod-span">改地址</span>中，将用户的<span class="blod-span">手机号码</span>改成<span class="blod-span">13512345678</span></p>
                            </template>
                        </div>
                    </div>
                    <div id="studytip-six" class="stoptip">
                        <div class="tip">
                            <span class="el-icon-success"></span>
                            <p>实操通关，进入下一关吧</p>
                            <p>
                                <a class="startstudy" @click="studyNext('#tab-seven', 7, 'seven')">GO，下一关</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div id="tab-seven-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'seven'}">
                    <!-- <div id="stoptip-seven" class="stoptip">
                        <div class="tip">
                            <span class="el-icon-success"></span>
                            <p>
                            <a class="startstudy" @click="startStudy">开始实操练习</a>
                            </p>
                        </div>
                    </div> -->
                    <div id="content-seven" class="content">
                        <div class="con-left">
                            <div v-show="isShowSeven" class="szbox">
                                <img class="szbg" src="../../../static/feige/7/1.png" />
                                <div @click="seven()" class="seven01"></div>
                            </div>
                            <div v-show="isShowSeven1" class="szbox">
                                <img class="szbg" src="../../../static/feige/7/2.png" />
                                <div @mouseenter="seven1()" class="seven02"></div>
                            </div>
                            <div v-show="isShowSeven2" class="szbox">
                                <img class="szbg" src="../../../static/feige/7/3.png" />
                                <div @click="seven2()" class="seven02"></div>
                            </div>
                            <div v-show="isShowSeven3" class="szbox">
                                <img class="szbg" src="../../../static/feige/7/4.png" />
                                <div @click="seven3()" class="seven01"></div>
                            </div>
                            <div v-show="isShowSeven4" class="szbox">
                                <img class="szbg" src="../../../static/feige/7/5.png" />
                                <div @click="seven4()" class="seven03"></div>
                            </div>
                            <div v-show="isShowSeven5" class="szbox">
                                <img class="szbg" src="../../../static/feige/7/6.png" />
                                <div @mouseenter="seven5()" class="seven04"></div>
                            </div>
                            <div v-show="isShowSeven6" class="szbox">
                                <img class="szbg" src="../../../static/feige/7/7.png" />
                                <div @click="seven6()" class="seven04"></div>
                            </div>
                            <div v-show="isShowSeven7" class="szbox">
                                <img class="szbg" src="../../../static/feige/7/8.png" />
                                <div @mouseenter="seven7()" class="seven05"></div>
                            </div>
                            <div v-show="isShowSeven8" class="szbox">
                                <img class="szbg" src="../../../static/feige/7/9.png" />
                                <div @click="seven8()" class="seven05"></div>
                            </div>
                            <div v-show="isShowSeven9" class="szbox">
                                <img class="szbg" src="../../../static/feige/7/10.png" />
                                <div @mouseenter="seven9()" class="seven06"></div>
                            </div>
                            <div v-show="isShowSeven10" class="szbox">
                                <img class="szbg" src="../../../static/feige/7/11.png" />
                                <img v-if="isShowSmallPic" class="small-img" src="../../../static/feige/7/12.png" />
                                <div v-if="!isShowSmallPic" @contextmenu.prevent="seven10()" class="seven06"></div>
                                <div v-if="isShowSmallPic" @click="seven11()" class="seven07"></div>
                            </div>
                            <div v-show="isShowSeven11" class="szbox">
                                <img class="szbg" src="../../../static/feige/7/13.png" />
                            </div>
                        </div>
                        <div class="con-right">
                            <h3>
                                <span class="line"></span>
                                提示
                            </h3>
                            <template v-if="isShowSeven || isShowSeven1 || isShowSeven2">
                                <p>请将状态切换为：<span class="blod-span">小休</span></p>
                            </template>
                            <template v-if="isShowSeven3 || isShowSeven4">
                                <p>请将状态切换为：<span class="blod-span">离线</span></p>
                            </template>
                            <template v-if="isShowSeven5 || isShowSeven6">
                                <p>请关闭<span class="blod-span">接待页面</span></p>
                            </template>
                            <template v-if="isShowSeven7 || isShowSeven8">
                                <p>请点击右下方显示隐藏的图标</p>
                            </template>
                            <template v-if="isShowSeven9 || isShowSeven10 || isShowSeven11">
                                <p>右键点击飞鸽小图标</p>
                            </template>
                        </div>
                    </div>
                    <div id="studytip-seven" class="stoptip" v-if="OnInline=='false'">
                        <div class="tip" style="width: 400px;height: 270px;">
                            <span class="el-icon-success"></span>
                            <!-- <p>你已完成千牛模拟实操，<br>接下来请完成《XXXXXX》。</p> -->
                            <!-- <a class="startstudy" href="/tjkStudy/simulate/jmStudy" style="width: 160px;">去完成京麦功能学习</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PDFObject from '../../assets/js/pdfobject.min'
    export default {
        data() {
            return {
                OnInline:'false',//小助手跳转
                tabCurrent: 'first', //当前标签页
                tabIndex: 1, //序号
                isShowBtn: [], //是否显示开始练习按钮
                isOpenPpt: false, //是否展开ppt
                isOpenPpt1: false, //是否展开ppt
                isOpenPpt2: false, //是否展开ppt
                isOpenPpt3: false, //是否展开ppt
                isOpenPpt4: false, //是否展开ppt
                isOpenPpt5: false, //是否展开ppt
                isOpenPpt6: false, //是否展开ppt
                //第1步
                isShowQnIcon: true, //是否显示飞鸽图标
                isShowQnIcon2: false, //显示点击飞鸽图标后图片
                isShowIcon3: false, //显示选择商家图片
                isShowIcon4: false, //显示切换手机号登录页面
                isShowIcon5: false,
                isShowIcon6: false,
                isShowIcon7: false,
                isShowIcon8: false,
                isShowLogin1: false,
                isShowLogin2: false,
                isShowLogin3: false,
                isShowLogin4: false,
                isShowLogin5: false,
                isShowLogin6: false,
                name: '', //登录账号
                password: '', //密码


                // 第二部
                isShowSetUp: true,
                isShowSetUp1: false,
                isShowSetUp2: false,
                isShowSetUp3: false,
                isShowSetUp4: false,
                isShowSetUp5: false,
                isShowSetUp6: false,
                isShowSetUp7: false,
                isShowSetUp8: false,
                isShowSetUp9: false,
                isShowSetUp10: false,

                // 第三步
                duanyuInputVal: '',
                duanyuInputVal1: '',
                downCount: 0,
                dyInput: '', //快捷短语输入
                dynr: '', //短语内容
                bmdy: '' ,//编码短语
                isShowSetDown: true,
                isShowSetDown1: false,
                isShowSetDown2: false,
                isShowSetDown3: false,
                isShowSetDown4: false,
                isShowSetDown5: false,
                isShowSetDown6: false,
                isShowSetDown7: false,
                isShowSetDown8: false,
                isShowSetDown9: false,
                isShowSetDown10: false,
                isShowSetDown11: false,
                isShowSetDown12: false,
                isShowSetDown13: false,
                isShowSetDown14: false,
                isShowSetDown15: false,
                isShowSetDown16: false,
                isShowSetDown17: false,
                isShowSetDown18: false,
                isShowSetDown19: false,
                isShowSetDown20: false,
                isShowSetDown21: false,
                isShowSetDown22: false,
                isShowSetDown23: false,
                isShowSetDown24: false,
                isShowSetDown25: false,
                isShowSetDown26: false,
                isShowSetDown27: false,
                isShowSetDown28: false,
                isShowSetDown29: false,
                isShowSetDown30: false,
                isShowSetDown31: false,
                isShowSetDown32: false,
                isShowSetDown33: false,
                isShowSetDown34: false,
                isShowSetDown35: false,
                isShowSetDown36: false,
                isShowSetDown37: false,
                isShowSetDown38: false,
                isShowSetDown39: false,
                isShowSetDown40: false,
                isShowSetDown41: false,
                isShowSetDown42: false,
                isShowSetDown43: false,
                isShowSetDown44: false,
                isShowSetDown45: false,
                isShowSetDown431: false,
                isShowSetDown432: false,
                isShowSetDown433: false,
                isShowSetDown434: false,
                isShowSetDown451: false,
                isShowSetDown452: false,

                // 第四步
                isShowSession: true,
                isShowSession1: false,
                isShowSession2: false,
                isShowSession3: false,
                isShowSession4: false,

                // 第五步
                isShowFive: true,
                isShowFive1: false,
                isShowFive2: false,
                isShowFive3: false,
                isShowFive4: false,
                isShowFive5: false,
                isShowFive6: false,
                isShowFive7: false,
                isShowFive8: false,
                isShowFive9: false,

                // 第六步
                isShowSix: true,
                beizhu: '',
                yjgj: '',
                yfInput: '',
                sjhm: '',
                isShowSix1: false,
                isShowSix2: false,
                isShowSix3: false,
                isShowSix4: false,
                isShowSix5: false,
                isShowSix6: false,
                isShowSix7: false,
                isShowSix8: false,
                isShowSix9: false,
                isShowSix10: false,
                isShowSix11: false,
                isShowSix12: false,
                isShowSix13: false,
                isShowSix14: false,
                isShowSix15: false,
                isShowSix16: false,
                isShowSix17: false,
                isShowSix18: false,
                isShowSix19: false,
                isShowSix20: false,
                isShowSix21: false,
                isShowSix22: false,
                isShowSix23: false,
                isShowSix24: false,

                // 第七步
                isShowSeven: true,
                isShowSeven1: false,
                isShowSeven2: false,
                isShowSeven3: false,
                isShowSeven4: false,
                isShowSeven5: false,
                isShowSeven6: false,
                isShowSeven7: false,
                isShowSeven8: false,
                isShowSeven9: false,
                isShowSeven10: false,
                isShowSeven11: false,
                isShowSmallPic: false
            }
        },

        mounted() {
            $('#stoptip-'+this.tabCurrent).show();
            this.initAll();
            var step = this.$route.query.step;
            if(step == 7){
                this.studyNext('#tab-seven', step, 'seven')
            }
            // 去掉双击事件默认选中
            let select = document.getElementById('select')
            select.onmousedown = () => {
                return false
            }
        },
        watch: {
            kjdy: function() {
                if(this.kjdy == '/结束') {
                    this.isShowKjdy06 = true
                }
            }
        },
        directives: {
            focus: {
                inserted: function(el, {value}) {
                    if(value){
                        el.focus();
                    }
                }
            }
        },
        created(){
            if(this.$route.query.OnInline){
                this.OnInline=this.$route.query.OnInline
            }
        },

        methods: {
            startStudy() {
                $('#stoptip-'+this.tabCurrent).hide();
                $('#content-'+this.tabCurrent).show();
                this.addRecord('START', 1);
            },
            //下一关
            studyNext(next, index, tabCurrent) {
                $('.el-tabs__header').find('.js-tab').each(function() {
                    $(this).removeClass('is-active');
                });
                $(next).addClass('is-active');
                $('.el-tabs__content').find('.el-tab-pane').each(function() {
                    $(this).hide();
                });
                $(next+'-content').show();
                this.tabCurrent = tabCurrent;
                this.addRecord('START', index);
            },
            initFirst() {
                this.name = ''
                this.password = ''
                this.isShowQnIcon = true
                this.isShowQnIcon2 = false
                this.isShowIcon3 = false
                this.isShowIcon4 = false
                this.isShowIcon5 = false
                this.isShowIcon6 = false
                this.isShowIcon7 = false
                this.isShowIcon8 = false
                this.isShowLogin1 = false
                this.isShowLogin2 = false
                this.isShowLogin3 = false
                this.isShowLogin4 = false
                this.isShowLogin5 = false
                this.isShowLogin6 = false
            },
            initSecond() {
                this.isShowSetUp = true
                this.isShowSetUp1 = false
                this.isShowSetUp2 = false
                this.isShowSetUp3 = false
                this.isShowSetUp4 = false
                this.isShowSetUp5 = false
                this.isShowSetUp6 = false
                this.isShowSetUp7 = false
                this.isShowSetUp8 = false
                this.isShowSetUp9 = false
                this.isShowSetUp10 = false
            },
            initThird() {
                this.downCount = 0
                this.duanyuInputVal = ''
                this.duanyuInputVal1 = ''
                this.dyInput = '', //快捷短语输入
                    this.dynr = '', //短语内容
                    this.bmdy = '' ,//编码短语
                    this.isShowSetDown = true
                this.isShowSetDown1 = false
                this.isShowSetDown2 = false
                this.isShowSetDown3 = false
                this.isShowSetDown4 = false
                this.isShowSetDown5 = false
                this.isShowSetDown6 = false
                this.isShowSetDown7 = false
                this.isShowSetDown8 = false
                this.isShowSetDown9 = false
                this.isShowSetDown10 = false
                this.isShowSetDown11 = false
                this.isShowSetDown12 = false
                this.isShowSetDown13 = false
                this.isShowSetDown14 = false
                this.isShowSetDown15 = false
                this.isShowSetDown16 = false
                this.isShowSetDown17 = false
                this.isShowSetDown18 = false
                this.isShowSetDown19 = false
                this.isShowSetDown20 = false
                this.isShowSetDown21 = false
                this.isShowSetDown22 = false
                this.isShowSetDown23 = false
                this.isShowSetDown24 = false
                this.isShowSetDown25 = false
                this.isShowSetDown26 = false
                this.isShowSetDown27 = false
                this.isShowSetDown28 = false
                this.isShowSetDown29 = false
                this.isShowSetDown30 = false
                this.isShowSetDown31 = false
                this.isShowSetDown32 = false
                this.isShowSetDown33 = false
                this.isShowSetDown34 = false
                this.isShowSetDown35 = false
                this.isShowSetDown36 = false
                this.isShowSetDown37 = false
                this.isShowSetDown38 = false
                this.isShowSetDown39 = false
                this.isShowSetDown40 = false
                this.isShowSetDown41 = false
                this.isShowSetDown42 = false
                this.isShowSetDown43 = false
                this.isShowSetDown44 = false
                this.isShowSetDown45 = false
                this.isShowSetDown431 = false
                this.isShowSetDown432 = false
                this.isShowSetDown433 = false
                this.isShowSetDown434 = false
                this.isShowSetDown451 = false
                this.isShowSetDown452 = false
            },
            initFour() {
                this.isShowSession =true
                this.isShowSession1 = false
                this.isShowSession2 = false
                this.isShowSession3 = false
                this.isShowSession4 = false
            },
            initFive() {
                this.isShowFive = true
                this.isShowFive1 = false
                this.isShowFive2 = false
                this.isShowFive3 = false
                this.isShowFive4 = false
                this.isShowFive5 = false
                this.isShowFive6 = false
                this.isShowFive7 = false
                this.isShowFive8 = false
                this.isShowFive9 = false
            },
            initSix() {
                this.beizhu = ''
                this.yjgj = ''
                this.yfInput = ''
                this.sjhm = ''
                this.isShowSix = true
                this.isShowSix1 = false
                this.isShowSix2 = false
                this.isShowSix3 = false
                this.isShowSix4 = false
                this.isShowSix5 = false
                this.isShowSix6 = false
                this.isShowSix7 = false
                this.isShowSix8 = false
                this.isShowSix9 = false
                this.isShowSix10 = false
                this.isShowSix11 = false
                this.isShowSix12 = false
                this.isShowSix13 = false
                this.isShowSix14 = false
                this.isShowSix15 = false
                this.isShowSix16 = false
                this.isShowSix17 = false
                this.isShowSix18 = false
                this.isShowSix19 = false
                this.isShowSix20 = false
                this.isShowSix21 = false
                this.isShowSix22 = false
                this.isShowSix23 = false
                this.isShowSix24 = false
            },
            initSeven() {
                this.isShowSeven = true
                this.isShowSeven1 = false
                this.isShowSeven2 = false
                this.isShowSeven3 = false
                this.isShowSeven4 = false
                this.isShowSeven5 = false
                this.isShowSeven6 = false
                this.isShowSeven7 = false
                this.isShowSeven8 = false
                this.isShowSeven9 = false
                this.isShowSeven10 = false
                this.isShowSeven11 = false
                this.isShowSmallPic = false
            },
            initAll() {
                //第1步
                this.initFirst()
                //第2步
                this.initSecond()
                //第3步
                this.initThird()
                //第4步
                this.initFour()
                //第5步
                this.initFive()
                //第6步
                this.initSix()
                //第7步
                this.initSeven()
            },


            //第1步-单击图标
            showLoginImg() {
                this.isShowQnIcon = false
                this.isShowQnIcon2 = true
            },
            //双击图标
            showLoginImg2() {
                this.isShowQnIcon2 = false
                this.isShowIcon3 = true
            },
            showLoginImg3() {
                this.isShowIcon3 = false
                this.isShowIcon4 = true
            },
            showLoginImg4() {
                this.isShowIcon4 = false
                this.isShowIcon5 = true
            },
            showLoginImg5() {
                this.isShowIcon5 = false
                this.isShowIcon6 = true
            },
            showLoginImg6() {
                this.isShowIcon6 = false
                this.isShowIcon7 = true
            },
            showLoginImg7() {
                this.isShowIcon7 = false
                this.isShowIcon8 = true
            },
            loginIn() {
                if(this.name == '') {
                    this.notify('<p>请输入账号</p>')
                    return
                }else if(this.name != '13853678478') {
                    this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
                    return
                }
                if(this.password == '') {
                    this.notify('<p>请输入密码</p>')
                    return
                }else if(this.password != '3346') {
                    this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
                    return
                }
                this.isShowIcon8 = false
                this.isShowLogin1 = true
            },
            loginIn1() {
                this.isShowLogin1 = false
                this.isShowLogin2 = true
            },
            loginIn2() {
                this.isShowLogin2 = false
                this.isShowLogin3 = true
            },
            loginIn3() {
                this.isShowLogin3 = false
                this.isShowLogin4 = true
            },
            loginIn4() {
                var self = this
                this.isShowLogin4 = false
                this.isShowLogin5 = true
                this.addRecord('END',1)
                setTimeout(function() {
                    $('#studytip-'+self.tabCurrent).show();
                }, 2000);
            },

            // 第二布  设置上事件
            setUp() {
                this.isShowSetUp = false
                this.isShowSetUp1 = true
            },
            setUp1() {
                this.isShowSetUp1 = false
                this.isShowSetUp2 = true
            },
            setUp2() {
                this.isShowSetUp2 = false
                this.isShowSetUp3 = true
            },
            setUp3() {
                this.isShowSetUp3 = false
                this.isShowSetUp4 = true
            },
            setUp4() {
                this.isShowSetUp4 = false
                this.isShowSetUp5 = true
            },
            setUp5() {
                this.isShowSetUp5 = false
                this.isShowSetUp6 = true
            },
            setUp6() {
                this.isShowSetUp6 = false
                this.isShowSetUp7 = true
            },
            setUp7() {
                this.isShowSetUp7 = false
                this.isShowSetUp8 = true
            },
            setUp8() {
                this.isShowSetUp8 = false
                this.isShowSetUp9 = true
            },
            setUp9() {
                var self = this
                this.isShowSetUp9 = false
                this.isShowSetUp10 = true
                this.addRecord('END',2)
                setTimeout(function() {
                    $('#studytip-'+self.tabCurrent).show();
                }, 2000);
            },

            // 第三步
            setDown() {
                this.isShowSetDown = false
                this.isShowSetDown1 = true
            },
            setDown1() {
                this.isShowSetDown1 = false
                this.isShowSetDown2 = true
            },
            setDown2() {
                this.isShowSetDown2 = false
                this.isShowSetDown3 = true
            },
            setDown3() {
                this.isShowSetDown3 = false
                this.isShowSetDown4 = true
            },
            setDown4() {
                this.isShowSetDown4 = false
                this.isShowSetDown5 = true
            },
            setDown5() {
                this.isShowSetDown5 = false
                this.isShowSetDown6 = true
            },
            setDown6() {
                this.isShowSetDown6 = false
                this.isShowSetDown7 = true
            },
            setDown7() {
                this.isShowSetDown7 = false
                this.isShowSetDown8 = true
            },
            setDown8() {
                this.isShowSetDown8 = false
                this.isShowSetDown9 = true
            },
            setDown9() {
                this.isShowSetDown9 = false
                this.isShowSetDown10 = true
            },
            setDown10() {
                this.isShowSetDown10 = false
                this.isShowSetDown11 = true
            },
            setDown11() {
                if (this.dyInput == '催单') {
                    this.isShowSetDown11 = false
                    this.isShowSetDown12 = true
                } else {
                    this.notify('<p>请按照右边提示输入催单</p>')
                }

            },
            setDown12() {
                this.isShowSetDown12 = false
                this.isShowSetDown13 = true
            },
            setDown13() {
                this.isShowSetDown13 = false
                this.isShowSetDown14 = true
            },
            // 填写编码配置部分前后
            setDown14() {
                this.isShowSetDown14 = false
                this.isShowSetDown15 = true
            },
            setDown16() {
                if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
                    this.notify('<p>请按照右边提示输入正确的短语内容</p>')
                    return
                }
                this.isShowSetDown15 = false
                this.isShowSetDown16 = true
            },
            setDown17() {
                if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！' ) {
                    this.notify('<p>请按照右边提示输入正确的短语内容</p>')
                    return
                }
                if (this.bmdy != '催单') {
                    this.notify('<p>请按照右边提示输入正确的编码短语</p>')
                    return
                }
                this.isShowSetDown16 = false
                this.isShowSetDown19 = true
            },
            setDown15() {
                this.isShowSetDown14 = false
                this.isShowSetDown17 = true
            },
            setDown18() {
                if (this.bmdy != '催单') {
                    this.notify('<p>请按照右边提示输入正确的编码短语</p>')
                    return
                }
                this.isShowSetDown17 = false
                this.isShowSetDown18 = true
            },
            setDown19() {
                if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！' ) {
                    this.notify('<p>请按照右边提示输入正确的短语内容</p>')
                    return
                }
                if (this.bmdy != '催单') {
                    this.notify('<p>请按照右边提示输入正确的编码短语</p>')
                    return
                }
                this.isShowSetDown18 = false
                this.isShowSetDown19 = true
            },
            setDown20() {
                this.isShowSetDown19 = false
                this.isShowSetDown20 = true
                setTimeout(() => {
                    this.isShowSetDown20 = false
                    this.isShowSetDown21 = true
                }, 2000);
            },
            setDown22() {
                this.isShowSetDown21 = false
                this.isShowSetDown22 = true
            },
            setDown23() {
                this.isShowSetDown22 = false
                this.isShowSetDown23 = true
            },
            setDown24() {
                this.isShowSetDown23 = false
                this.isShowSetDown24 = true
            },
            setDown25() {
                this.isShowSetDown24 = false
                this.isShowSetDown25 = true
            },
            // 先勾选
            // setDown241() {
            //     this.isShowSetDown24 = false
            //     this.isShowSetDown271 = true
            // },
            // setDown281() {
            //     this.isShowSetDown271 = false
            //     this.isShowSetDown281 = true
            // },


            setDown26() {
                this.isShowSetDown25 = false
                this.isShowSetDown26 = true
            },
            setDown27() {
                this.isShowSetDown26 = false
                this.isShowSetDown27 = true
            },
            setDown28() {
                this.isShowSetDown27 = false
                this.isShowSetDown28 = true
            },
            setDown29() {
                this.isShowSetDown28 = false
                this.isShowSetDown29 = true
            },
            setDown30() {
                this.isShowSetDown29 = false
                this.isShowSetDown30 = true
                setTimeout(() => {
                    this.isShowSetDown30 = false
                    this.isShowSetDown31 = true
                }, 2000);
            },
            setDown32() {
                this.isShowSetDown31 = false
                this.isShowSetDown32 = true
            },
            setDown33() {
                if(this.downCount == 0) {
                    this.$alert('请先下载飞鸽快捷短语模板')
                    return false
                }
                this.isShowSetDown32 = false
                this.isShowSetDown33 = true
            },
            setDown34() {
                this.isShowSetDown33 = false
                this.isShowSetDown34 = true
            },

            setDown36() {
                this.isShowSetDown35 = false
                this.isShowSetDown36 = true
            },
            setDown37() {
                this.isShowSetDown36 = false
                this.isShowSetDown37 = true
                setTimeout(() => {
                    this.isShowSetDown37 = false
                    this.isShowSetDown38 = true
                }, 2000);
            },
            setDown39() {
                this.isShowSetDown38 = false
                this.isShowSetDown39 = true
            },
            setDown40() {
                this.isShowSetDown39 = false
                this.isShowSetDown40 = true
            },
            setDown41() {
                this.isShowSetDown40 = false
                this.isShowSetDown41 = true
            },
            setDown42() {
                this.isShowSetDown41 = false
                this.isShowSetDown42 = true
            },
            setDown43() {
                this.isShowSetDown42 = false
                this.isShowSetDown43 = true
                setTimeout(() => {
                    this.isShowSetDown43 = false
                    this.isShowSetDown431 = true
                }, 1500);
            },

            duanyuInput(e) {
                if (e.target.value == '/您好') {
                    this.isShowSetDown431 = false
                    this.isShowSetDown432 = true
                    // this.isShowSetDown44 = true
                }
            },
            setDown432() {
                this.isShowSetDown432 = false
                this.isShowSetDown433 = true
                setTimeout(() => {
                    this.isShowSetDown433 = false
                    this.isShowSetDown434 = true
                }, 2000);
            },
            duanyuInput1(e) {
                if (e.target.value == '您好') {
                    this.isShowSetDown434 = false
                    this.isShowSetDown44 = true
                }
            },
            setDown45() {
                this.isShowSetDown44 = false
                this.isShowSetDown45 = true
            },
            setDown46() {
                this.isShowSetDown45 = false
                this.isShowSetDown451 = true
            },
            setDown461() {
                var self = this
                this.isShowSetDown451 = false
                this.isShowSetDown452 = true
                this.addRecord('END',3)
                setTimeout(function() {
                    $('#studytip-'+self.tabCurrent).show();
                }, 2000);
            },



            // 下载快捷短语
            downloadKjdyFile() {
                this.downCount = 1
                // indow.open(('//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'),"_blank")
                let path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'
                const downloadRes = async () => {
                    let response = await fetch(path);
                    let blob = await response.blob();
                    let objectUrl = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = objectUrl;
                    a.download = '飞鸽快捷短语.csv';
                    a.click()
                    a.remove();
                }
                downloadRes();
                this.isShowKjdyTip03 = false
                this.isShowKjdyTip04 = true
            },

            // 第四步  操作
            four() {
                this.isShowSession = false
                this.isShowSession1 = true
            },
            four1() {
                this.isShowSession1 = false
                this.isShowSession2 = true
            },
            four2() {
                this.isShowSession2 = false
                this.isShowSession3 = true
            },
            four3() {
                var self = this
                this.isShowSession3 = false
                this.isShowSession4 = true
                this.addRecord('END',4)
                setTimeout(function() {
                    $('#studytip-'+self.tabCurrent).show();
                }, 2000);
            },

            // 第五步
            five() {
                this.isShowFive = false
                this.isShowFive1 = true
            },
            five1() {
                this.isShowFive1 = false
                this.isShowFive2 = true
            },
            five2() {
                this.isShowFive2 = false
                this.isShowFive3 = true
            },
            five3() {
                this.isShowFive3 = false
                this.isShowFive4 = true
                setTimeout(() => {
                    this.isShowFive4 = false
                    this.isShowFive5 = true
                }, 2000);
            },

            five5() {
                this.isShowFive5 = false
                this.isShowFive6 = true
            },
            five6() {
                this.isShowFive6 = false
                this.isShowFive7 = true
            },
            five7() {
                this.isShowFive7 = false
                this.isShowFive8 = true
            },
            five8() {
                var self = this
                this.isShowFive8 = false
                this.isShowFive9 = true
                this.addRecord('END',5)
                setTimeout(function() {
                    $('#studytip-'+self.tabCurrent).show();
                }, 2000);
            },

            // 第六步
            six() {
                this.isShowSix = false
                this.isShowSix1 = true
            },
            six1() {
                this.isShowSix1 = false
                this.isShowSix2 = true
            },
            beiZhuInput(e) {
                if (e.target.value == '用户要求发顺丰') {
                    this.isShowSix2 = false
                    this.isShowSix3 = true
                }
            },
            six121() {
                if (this.beizhu != '用户要求发顺丰') {
                    this.notify('<p>请按照右边提示输入正确的备注内容</p>')
                } else {
                    this.notify('<p>请按照右边提示选择对应的彩旗</p>')
                }
            },
            six122() {
                if (this.beizhu != '用户要求发顺丰') {
                    this.notify('<p>请按照右边提示输入正确的备注内容</p>')
                }
            },
            six3() {
                this.isShowSix3 = false
                this.isShowSix4 = true
            },
            six4() {
                this.isShowSix4 = false
                this.isShowSix5 = true
            },
            six5() {
                this.isShowSix5 = false
                this.isShowSix6 = true
                setTimeout(() => {
                    this.isShowSix6 = false
                    this.isShowSix7 = true
                }, 2000);
            },
            six6() {
                this.isShowSix7 = false
                this.isShowSix8 = true
            },
            six7() {
                this.isShowSix8 = false
                this.isShowSix9 = true
                setTimeout(() => {
                    this.isShowSix9 = false
                    this.isShowSix10 = true
                }, 2000);
            },
            six8() {
                this.isShowSix10 = false
                this.isShowSix11 = true
            },
            six9() {
                this.isShowSix11 = false
                this.isShowSix12 = true
                setTimeout(() => {
                    this.isShowSix12 = false
                    this.isShowSix13 = true
                }, 2000);
            },
            six10() {
                this.isShowSix13 = false
                this.isShowSix14 = true
            },
            six11() {
                this.isShowSix14 = false
                this.isShowSix15 = true
            },
            six12() {
                if (this.yjgj != '48') {
                    this.notify('<p>请按照右边提示输入正确的一键改价价格</p>')
                    return
                }
                if (this.yfInput != '10') {
                    this.notify('<p>请按照右边提示输入正确的运费价格</p>')
                    return
                }
                this.isShowSix15 = false
                this.isShowSix16 = true
            },
            six13() {
                this.isShowSix16 = false
                this.isShowSix17 = true
                setTimeout(() => {
                    this.isShowSix17 = false
                    this.isShowSix18 = true
                }, 2000);
            },

            six14 () {
                this.isShowSix18 = false
                this.isShowSix19 = true
            },
            six15 () {
                this.isShowSix19 = false
                this.isShowSix20 = true
            },
            six16 () {
                this.isShowSix20 = false
                this.isShowSix21 = true
            },

            six17() {
                if (this.sjhm != '13512345678') {
                    this.notify('<p>请按照右边提示输入正确的手机号码</p>')
                    return
                }
                this.isShowSix21 = false
                this.isShowSix22 = true
            },
            six18() {
                var self = this
                this.isShowSix22 = false
                this.isShowSix23 = true
                this.addRecord('END',6)
                setTimeout(function() {
                    $('#studytip-'+self.tabCurrent).show();
                }, 2000);
            },

            // 第七步
            seven() {
                this.isShowSeven = false
                this.isShowSeven1 = true
            },
            seven1() {
                this.isShowSeven1 = false
                this.isShowSeven2 = true
            },
            seven2() {
                this.isShowSeven2 = false
                this.isShowSeven3 = true
            },
            seven3() {
                this.isShowSeven3 = false
                this.isShowSeven4 = true
            },
            seven4() {
                this.isShowSeven4 = false
                this.isShowSeven5 = true
            },
            seven5() {
                this.isShowSeven5 = false
                this.isShowSeven6 = true
            },
            seven6() {
                this.isShowSeven6 = false
                this.isShowSeven7 = true
            },
            seven7() {
                this.isShowSeven7 = false
                this.isShowSeven8 = true
            },
            seven8() {
                this.isShowSeven8 = false
                this.isShowSeven9 = true
            },
            seven9() {
                this.isShowSeven9 = false
                this.isShowSeven10 = true
            },
            seven10() {
                this.isShowSmallPic = true
            },
            seven11() {
                var self = this
                this.isShowSeven10 = false
                this.isShowSmallPic = false
                this.isShowSeven11 = true
                this.addRecord('END',7)
                setTimeout(function() {
                    $('#studytip-'+self.tabCurrent).show();
                }, 2000);
            },

            tirggerFile($event) {
                let self = this
                var file = $event.target.files;
                if(!file[0] || file[0] && file[0].name.indexOf('飞鸽快捷短语')<0) {
                    this.$alert('请选择你下载的“飞鸽快捷短语.csv”模板文件')
                    return false
                }
                setTimeout(function() {
                    self.isShowSetDown34 = false
                    self.isShowSetDown35 = true
                }, 500);
            },
            // 记录接口
            addRecord(type,index) {
                var data = {
                    exerciseType: 'FEIGE_EXAM_11618',
                    stepSeq: index,
                    exerciseAction: type
                }
                this.$http.post(API_ROOT.newcustomer + '/simulationExercise/addRecord', data).then(res=> {
                    var result = res.data
                    if(result.success) {
                        if(index==7 && type=='END'){
                            window.parent['goBack']();
                        }
                    }else {
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            center: true,
                            duration: 1000
                        })
                    }
                },res=> {
                    this.$message({
                        message: "网络繁忙，请稍后重试！",
                        type: 'error',
                        center: true,
                        duration: 1000
                    })
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    .account-table {
        border-top: 1px solid #000000;
        border-left: 1px solid #000000;
        margin: 10px;
        border-spacing: inherit;
        > tr > td {
            border-right: 1px solid #000000;
            border-bottom: 1px solid #000000;
            padding: 5px;
        }
    }
    .blod-span {
        color: red;
        font-weight:bold;
    }
    .mynone {
        display: none !important;
    }
</style>


// WEBPACK FOOTER //
// ./src/page/flying/feiGeTrainexam_11618.vue